import React from 'react';

type Props = {
  testId?: string;
};

import { loading } from '@portal/config/app.json';
import icLoading from '/assets/svg/ic_loading.svg';

const LoadingFadeStyles = {
  WebkitAnimation: 'flickerAnimation 2s infinite',
  MozAnimation: 'flickerAnimation 2s infinite',
  OAnimation: 'flickerAnimation 2s infinite',
  animation: 'flickerAnimation 2s infinite',
};

const Loading = ({ testId = '' }: Props) => {
  return (
    <div {...{ testId }} className="loading">
      <div
        className="loading__inner"
        style={loading.animation ? LoadingFadeStyles : undefined}
      >
        <img
          className="loading__inner__img"
          src={icLoading}
          alt="loading logo"
        />
      </div>
    </div>
  );
};

export default Loading;
